import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { Observable } from 'rxjs';
import { BasicApiResponseModel } from '../../../shared/api-response.model';
import { ApiVisa } from '../../../shared/api-visa.model';


@Injectable({
  providedIn: 'root'
})
export class IssueTrackerReportService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.SENHENG_PREFIX +'issue/report';
    this.endpoint_path = Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.SENHENG_PREFIX +'issue/report';
    this.httpClient = http;
  }

  downloadCsvReport(query: string, visa: ApiVisa): Observable<Blob>{
    let url = this.apiUrl + '/export/csv';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/export/csv';
    }

    return this.httpClient.post<Blob>(url, {"subquery": query},this.getHttpHeaderBlob(visa));
  }
}
